import {baseRequestService} from "../base.ts";
import {FIR} from "../../types/domain.ts";

export const firsGet = () => baseRequestService<FIR[]>({
    url: '/firs',
    method: 'GET',
})